export function setPleiqCode(payload) {
  return {
    type: 'SET_PLEIQ_CODE',
    payload
  };
}
